import React, { Component } from "react";
import "../App.css";
import ZenBanner from "../images/Zen/zen-banner.png";
import CloseArrow from "../images/close_arrow.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class Zen extends Component {
  state = {
    bookList: [
      {
        id: 1,
        title: "Zen and the Art of Making a Living",
        author: "Laurence G. Boldt",
        preview:
          "With today's economic uncertainties, millions of Americans realize they must seize control over their own career paths. They want work that not only pays the bills but also allows them to pursue their real passions. In this revised edition, Laurence Boldt updates and revises his revolutionary guide to meet the challenges of the twenty-first century workplace. The first part of this book helps readers to identify the work that they really want to do, while the second provides practical, active steps to finding or creating that work. Zen and the Art of Making a Living goes beyond inspiration, providing a proven formula for bringing creativity, dignity, and meaning to every aspect of the work experience.",
      },
      {
        id: 2,
        title: "Instructions to the Cook",
        author: "Bernie Glassman & Rick Fields",
        preview:
          "Zen is not just about what we do in the meditation hall, but what we do in the home, the workplace, and the community. That's the premise of this book: how to cook what Zen Buddhists call 'the supreme meal'—life. It has to be nourishing, and it has to be shared. And we can use only the ingredients at hand. Inspired by the thirteenth-century manual of the same name by Dogen, the founder of the Japanese Soto Zen tradition, this book teaches us how we can 'enlarge the family we're feeding' if we just use some imagination.",
      },
      {
        id: 3,
        title: "The Art of Taking Action",
        author: "Gregg Krech",
        preview:
          "Drawing on Eastern philosophy, Buddhism, Japanese Psychology, Zen, the Samurai, and Martial Arts, Gregg Krech offers an approach to ACTION that guides you to doing what is important for you to do in the time you have available. Most of us associate Eastern wisdom with meditation and contemplation. Krech offers a complimentary collection of wisdom on the Art of Taking Action that will help you take action even when you don’t feel like it. This isn’t just another “how to get things done” book. It’s about how you do what you do, and the impact that your action (and inaction) has on the world.",
      },
      {
        id: 4,
        title: "Nothing Special",
        author: "Charlotte Joko Beck & Steve Smith",
        preview:
          "WHEN NOTHING IS SPECIAL, EVERYTHING CAN BE. The best-selling author of 'Everyday Zen' shows how to awaken to daily life and discover the ideal in the everyday, finding riches in our feelings, relationships, and work. 'Nothing Special' offers the rare and delightful experience of learning in the authentic Buddhist tradition with a wonderfully contemporary Western master.",
      },
      {
        id: 5,
        title: "Feng Shui that Makes Sense",
        author: "Cathleen McCandless",
        preview:
          "You don't need to be a professional designer or a feng shui expert in order to have a beautiful, comfortable home. Feng Shui That Makes Sense takes you step-by-step through the process of using feng shui principles to create a home that will please your eye, relax your body, inspire your mind, and lift your spirit.",
      },
      {
        id: 6,
        title: "High-Vibe Feng Shui",
        author: "Ashley Cantley & Sophie Jaffe",
        preview:
          "The keys to manifesting major life transformation are within reach! In this fresh interpretation of the ancient art of Feng Shui, certified practitioner Ashley Cantley offers the simple and straightforward guide she wishes she’d had when she started learning about Feng Shui. Cantley’s 11-step program demystifies foundational ideas and practices, with guided exercises for creating intention, tapping into intuition, cleaning and decluttering, and balancing and enhancing energy in your home. But this is no rule book! Cantley’s process for eliminating blockages, realizing goals, and “living in the flow” is designed to be customized to anyone’s desires, experiences, and style.",
      },
      {
        id: 7,
        title: "A Master Course in Feng-Shui",
        author: "Eva Wong",
        preview:
          "This fully illustrated, comprehensive workbook is designed primarily for homeowners, renters, architects, and business owners who want to put feng-shui to practical personal use—to choose a home, build a house, select an office, or find a retail space. Real estate agents, interior designers, and architects will also find it useful as a reference manual.",
      },
      {
        id: 8,
        title: "Clear Your Clutter with Feng Shui",
        author: "Karen Kingston",
        preview:
          "Clutter is trapped energy that has far-reaching effects physically, mentally, emotionally, and spiritually. The simple act of clearing clutter can transform your life by releasing negative emotions, generating energy, and allowing you to create space in your life for the things you want to achieve. In Clear Your Clutter with Feng Shui, Karen Kingston, pioneer of a branch of Feng Shui known as Space Clearing, expertly guides you through the liberating task of clutter clearing.",
      },
    ],
  };

  handleBook1Click = () => {
    document
      .getElementById("bump-out-1")
      .classList.toggle("bump-out-slide-right");
  };

  handleBook2Click = () => {
    document
      .getElementById("bump-out-2")
      .classList.toggle("bump-out-slide-left");
  };

  handleBook3Click = () => {
    document
      .getElementById("bump-out-3")
      .classList.toggle("bump-out-slide-right");
  };

  handleBook4Click = () => {
    document
      .getElementById("bump-out-4")
      .classList.toggle("bump-out-slide-left");
  };

  handleBook5Click = () => {
    document
      .getElementById("bump-out-5")
      .classList.toggle("bump-out-slide-right");
  };

  handleBook6Click = () => {
    document
      .getElementById("bump-out-6")
      .classList.toggle("bump-out-slide-left");
  };

  handleBook7Click = () => {
    document
      .getElementById("bump-out-7")
      .classList.toggle("bump-out-slide-right");
  };

  handleBook8Click = () => {
    document
      .getElementById("bump-out-8")
      .classList.toggle("bump-out-slide-left");
  };

  render() {
    return (
      <div>
        <section className="time-banner-wrapper">
          <img className="Time-Banner" src={ZenBanner} alt="timebanner"></img>
          <div>
            <h1>Zen</h1>
            <p>Life is a balance of holding on and letting go</p>
          </div>
        </section>
        <section className="time-grid-container">
          <div className="grid-title">
            <h1>Popular Titles</h1>
            <input type="search" placeholder="search titles"></input>
          </div>

          {/* Book 1 */}
          <div className="bumpout-animation-wrapper book-1-position">
            <div id="bump-out-1" className="bump-out">
              <div className="bump-out-content-wrapper">
                <h2>Title:{this.state.bookList[0].title}</h2>
                <h2>Author: {this.state.bookList[0].author}</h2>
                <h2>
                  Rating:{" "}
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                </h2>
                <h2 className="text-alignment">
                  Preview:
                  <br />
                  <br />
                  {this.state.bookList[0].preview}
                </h2>
              </div>
              <button className="find-button" href="#" target="_blank">
                Find It
              </button>
              <a href="#" className="add-to-list">
                Add to List
              </a>
              <img
                className="close-bump-out-left"
                src={CloseArrow}
                onClick={this.handleBook1Click}
              />
            </div>
            <div
              className="zen-book1-cover book1-style"
              onClick={this.handleBook1Click}
            ></div>
          </div>

          {/* Book 2 */}
          <div className="bumpout-animation-wrapper book-2-position">
            <div id="bump-out-2" className="bump-out">
              <div className="bump-out-content-wrapper">
                <h2>Title:{this.state.bookList[1].title}</h2>
                <h2>Author: {this.state.bookList[1].author}</h2>
                <h2>
                  Rating:{" "}
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                </h2>
                <h2 className="text-alignment">
                  Preview:
                  <br />
                  <br />
                  {this.state.bookList[1].preview}
                </h2>
              </div>
              <button className="find-button" href="#" target="_blank">
                Find It
              </button>
              <a href="#" className="add-to-list">
                Add to List
              </a>
              <img
                className="close-bump-out-right"
                src={CloseArrow}
                onClick={this.handleBook2Click}
              />
            </div>
            <div
              className="zen-book2-cover book2-style"
              onClick={this.handleBook2Click}
            ></div>
          </div>

          {/* Book 3 */}
          <div className="bumpout-animation-wrapper book-3-position">
            <div id="bump-out-3" className="bump-out">
              <div className="bump-out-content-wrapper">
                <h2>Title:{this.state.bookList[2].title}</h2>
                <h2>Author: {this.state.bookList[2].author}</h2>
                <h2>
                  Rating:{" "}
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                </h2>
                <h2 className="text-alignment">
                  Preview:
                  <br />
                  <br />
                  {this.state.bookList[2].preview}
                </h2>
              </div>
              <button className="find-button" href="#" target="_blank">
                Find It
              </button>
              <a href="#" className="add-to-list">
                Add to List
              </a>
              <img
                className="close-bump-out-left"
                src={CloseArrow}
                onClick={this.handleBook3Click}
              />
            </div>
            <div
              className="zen-book3-cover book3-style"
              onClick={this.handleBook3Click}
            ></div>
          </div>

          {/* Book 4 */}
          <div className="bumpout-animation-wrapper book-4-position">
            <div id="bump-out-4" className="bump-out">
              <div className="bump-out-content-wrapper">
                <h2>Title:{this.state.bookList[3].title}</h2>
                <h2>Author: {this.state.bookList[3].author}</h2>
                <h2>
                  Rating:{" "}
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                </h2>
                <h2 className="text-alignment">
                  Preview:
                  <br />
                  <br />
                  {this.state.bookList[3].preview}
                </h2>
              </div>
              <button className="find-button" href="#" target="_blank">
                Find It
              </button>
              <a href="#" className="add-to-list">
                Add to List
              </a>
              <img
                className="close-bump-out-right"
                src={CloseArrow}
                onClick={this.handleBook4Click}
              />
            </div>
            <div
              className="zen-book4-cover book4-style"
              onClick={this.handleBook4Click}
            ></div>
          </div>

          {/* Book 5 */}
          <div className="bumpout-animation-wrapper book-5-position">
            <div id="bump-out-5" className="bump-out">
              <div className="bump-out-content-wrapper">
                <h2>Title:{this.state.bookList[4].title}</h2>
                <h2>Author: {this.state.bookList[4].author}</h2>
                <h2>
                  Rating:{" "}
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                </h2>
                <h2 className="text-alignment">
                  Preview:
                  <br />
                  <br />
                  {this.state.bookList[4].preview}
                </h2>
              </div>
              <button className="find-button" href="#" target="_blank">
                Find It
              </button>
              <a href="#" className="add-to-list">
                Add to List
              </a>
              <img
                className="close-bump-out-left"
                src={CloseArrow}
                onClick={this.handleBook3Click}
              />
            </div>
            <div
              className="zen-book5-cover book5-style"
              onClick={this.handleBook5Click}
            ></div>
          </div>

          {/* Book 6 */}
          <div className="bumpout-animation-wrapper book-6-position">
            <div id="bump-out-6" className="bump-out">
              <div className="bump-out-content-wrapper">
                <h2>Title:{this.state.bookList[5].title}</h2>
                <h2>Author: {this.state.bookList[5].author}</h2>
                <h2>
                  Rating:{" "}
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                </h2>
                <h2 className="text-alignment">
                  Preview:
                  <br />
                  <br />
                  {this.state.bookList[5].preview}
                </h2>
              </div>
              <button className="find-button" href="#" target="_blank">
                Find It
              </button>
              <a href="#" className="add-to-list">
                Add to List
              </a>
              <img
                className="close-bump-out-right"
                src={CloseArrow}
                onClick={this.handleBook4Click}
              />
            </div>
            <div
              className="zen-book6-cover book6-style"
              onClick={this.handleBook6Click}
            ></div>
          </div>

          {/* Book 7 */}
          <div className="bumpout-animation-wrapper book-7-position">
            <div id="bump-out-7" className="bump-out">
              <div className="bump-out-content-wrapper">
                <h2>Title:{this.state.bookList[6].title}</h2>
                <h2>Author: {this.state.bookList[6].author}</h2>
                <h2>
                  Rating:{" "}
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                </h2>
                <h2 className="text-alignment">
                  Preview:
                  <br />
                  <br />
                  {this.state.bookList[6].preview}
                </h2>
              </div>
              <button className="find-button" href="#" target="_blank">
                Find It
              </button>
              <a href="#" className="add-to-list">
                Add to List
              </a>
              <img
                className="close-bump-out-left"
                src={CloseArrow}
                onClick={this.handleBook7Click}
              />
            </div>
            <div
              className="zen-book7-cover book7-style"
              onClick={this.handleBook7Click}
            ></div>
          </div>

          {/* Book 8 */}
          <div className="bumpout-animation-wrapper book-8-position">
            <div id="bump-out-8" className="bump-out">
              <div className="bump-out-content-wrapper">
                <h2>Title:{this.state.bookList[7].title}</h2>
                <h2>Author: {this.state.bookList[7].author}</h2>
                <h2>
                  Rating:{" "}
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                </h2>
                <h2 className="text-alignment">
                  Preview:
                  <br />
                  <br />
                  {this.state.bookList[7].preview}
                </h2>
              </div>
              <button className="find-button" href="#" target="_blank">
                Find It
              </button>
              <a href="#" className="add-to-list">
                Add to List
              </a>
              <img
                className="close-bump-out-right"
                src={CloseArrow}
                onClick={this.handleBook8Click}
              />
            </div>
            <div
              className="zen-book8-cover book8-style"
              onClick={this.handleBook8Click}
            ></div>
          </div>
        </section>
      </div>
    );
  }
}

export default Zen;
